import { GptOptionsType } from '../types';
import IconChatgpt from '@/pages/opinion/assets/svg/icon-chatgpt.svg';
import IconDeepseek from '@/pages/opinion/assets/svg/icon-deepseek.svg';
import IconGemini from '@/pages/opinion/assets/svg/icon-gemini.png';

export const gptOptionsTextMap: { [key in GptOptionsType]: string } = {
  basic: 'General Summary',
  advanced: 'Advanced Quantitative Summary',
};

export const gptOptionsCnTextMap: { [key in GptOptionsType]: string } = {
  basic: '基础总结',
  advanced: '高级量化总结',
};

export const gptOptionsShortTextMap: { [key in GptOptionsType]: string } = {
  basic: 'Basic',
  advanced: 'Advanced',
};

export const SAVE_PAGE_NAME = 'PAGE_NAME';
export type AIModalType =
  | 'deepseek'
  | 'gpt'
  | 'gemini'
  | 'gpt4.1'
  | 'gemini_3_flash';
export const AiIconMap: { [key in AIModalType]: string } = {
  deepseek: IconDeepseek,
  gpt: IconChatgpt,
  gemini: IconGemini,
  gemini_3_flash: IconGemini,
  'gpt4.1': IconChatgpt,
};

export const AI_MODAL_OPTIONS: { value: AIModalType; text: string }[] = [
  { value: 'gemini', text: 'Gemini' },
  { value: 'gpt', text: 'ChatGPT' },
  { value: 'deepseek', text: 'DeepSeek' },
];

export const GPT_TRIGGER_AGENT = [
  { value: 'gemini_3_flash', text: 'Gemini' },
  { value: 'gpt4.1', text: 'ChatGPT' },
];

export const DEFAULT_MODAL = "gemini";
